import ComicCard from '@/components/base/ComicCard';
import { comics } from '@/mocks/comics';

export default function FeaturedSection() {
  const featuredComics = comics.filter((c) => c.featured);

  return (
    <section className="py-14 md:py-20">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8">
          <div>
            <span className="text-xs font-semibold text-primary-500 uppercase tracking-wider">Editor&apos;s Pick</span>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mt-1 font-heading">
              <strong>精选推荐</strong>
            </h2>
            <p className="text-sm text-foreground-500 mt-2">编辑精选的高品质韩漫，每一部都值得细细品味</p>
          </div>
          <a href="/category/all" className="hidden md:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap font-medium">
            查看全部 <i className="ri-arrow-right-line"></i>
          </a>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5" data-product-shop>
          {featuredComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} variant="compact" />
          ))}
        </div>
        <a href="/category/all" className="md:hidden flex items-center justify-center gap-1 text-sm text-primary-500 mt-6 font-medium">
          查看全部 <i className="ri-arrow-right-line"></i>
        </a>
      </div>
    </section>
  );
}